import React, { PureComponent } from "react";

export class GridItem extends PureComponent {
  render() {
    const { icon, iconTitle, onClick, className } = this.props;

    return (
      <div className={ `weui-grid ${className}` } role="button" tabIndex={ 0 } onClick={ onClick } onKeyDown={ onClick }>
        <div className="weui-grid__icon">
          <i className={ `iconfont ${icon} text-3xl` }></i>
        </div>
        <p className="weui-grid__label pt-2">{ iconTitle }</p>
      </div>
    );
  }
}
